<template>
  <v-row>
    <v-col cols="12" xs="12">
      <span class="headline font-weight-light">Mail Template</span>
    </v-col>
    <v-col cols="12" xs="12">
      <v-form>
        <v-row>
          <v-col cols="12" xs="12" sm="10" md="6">
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                    label="Name"
                    clearable
                    height="56"
                    outlined
                    v-model="formData.name"
                    dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-text-field
                    label="Betreff"
                    clearable
                    outlined
                    v-model="formData.subject"
                    dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                    label="E-Mail Text"
                    auto-grow
                    outlined
                    v-model="formData.body"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-btn @click="cancelItem()" small class="text-none">Abbrechen</v-btn>
              </v-col>
              <v-col cols="6" class="py-0 text-right">
                <v-btn @click="updateItem()" small color="primary" class="text-none" >Speichern
                </v-btn>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'MailDefault',
  components: {},
  data() {
    return {
      statusList: [
        {
          key: 0,
          title: 'Nein'
        },
        {
          key: 1,
          title: 'Ja'
        }
      ],
      guid: 0,
      formData: {
        name: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        changed: ''
      },
      progress: 100,
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      }
    }
  },
  methods: {
    onGetData: function (data) {
      console.log('deviceGuid', data)
      this.formData = data
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
      this.cancelItem()
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Mails')
    },
    updateItem: function () {
      Vue.prototype.$api.updateMail(this.guid, this.formData, this.onItemUpdated)
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      this.progress = percent
    },
    onUploadSuccess(data) {
      console.log('upload done', data)
      // this.$refs.table.reload(this.guid)
    }
  },
  mounted() {
    //Vue.prototype.$api.checkCredentials(this)
    this.guid = this.$route.params.guid
    Vue.prototype.$api.getMail(this.guid, this.onGetData)
  }
}
</script>

<style scoped>

</style>
